import React from 'react';
import { Layout } from '@/components/Layout';
import Advantages from '@/components/Technology/Advantages/Advantages';
import Application from '@/components/Technology/Application/Application';
import Approaches from '@/components/Technology/Features/Approaches/Approaches';
import Highlights from '@/components/Technology/Features/Highlights/Highlights';
import Languages from '@/components/Technology/Languages/Languages';
import { Col, Container, Hero, Row } from '@visalex/core';

import cx from 'clsx';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import styles from '@/components/Technology/Technology.module.scss';

const prefix = 'technology';

const TechnologyPage = () => {
  const { t } = useTranslation();

  return (
    <Layout title={t(`${prefix}.seo-title`)} description={t(`${prefix}.seo-description`)}>
      <div className={cx(styles[`${prefix}`])}>
        <Hero className={styles[`${prefix}__hero`]}>
          <Col xs={12}>
            <Row className="align-items-center">
              <Col lg={6} md={6} className={styles[`${prefix}__hero_header`]}>
                <h1 className={cx(styles[`${prefix}__title`], styles[`${prefix}__hero_title`])}>
                  {t(`${prefix}.hero.title`)}
                </h1>
                <h6 className={cx(styles[`${prefix}__subtitle`], styles[`${prefix}__hero_subtitle`])}>
                  {t(`${prefix}.hero.subtitle`)}
                </h6>
              </Col>
              <Col lg={6} md={6} className={styles[`${prefix}__hero_image-container`]}>
                <img
                  src="/images/technology/header.png"
                  alt={t(`${prefix}.hero.imageAlt.technology-cover`)}
                  className={styles[`${prefix}__hero_image`]}
                />
              </Col>
            </Row>
          </Col>
        </Hero>
        <Container>
          <Row className={styles[`${prefix}__introduction`]}>
            <Col xl={12}>
              <p>{t(`${prefix}.intro.description`)}</p>
            </Col>
          </Row>
          <Advantages />
          <Highlights />
          <Approaches />
          <Languages />
          <Application />
        </Container>
      </div>
    </Layout>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
}
export default TechnologyPage;
